import styled from 'styled-components'
import { normalizeHeight, normalizeWidth } from '../../../utils/normalize';

export const InboxMessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const UsernameContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 20vw;
  overflow: hidden;
`;

export const Username = styled.h1`
  font-size: 14px;
  font-weight: 600;
  color: rgba(27, 27, 27, 1);
`;

export const LastMessage = styled.h2`
  font-size: 10px;
  color: #666666;
  overflow: hidden;
  white-space: nowrap;
`;

export const PurpleCircle = styled.div<{ $isOnline: boolean }>`
  height: ${normalizeHeight(10)};
  width: ${normalizeHeight(10)};
  border-radius: 50%;
  background-color: rgba(110, 48, 232, 1);
  opacity: ${props => props.$isOnline ? 1 : 0};
`;